// Fixed line shown under every AI answer, independent of what the AI says.
export const AI_DISCLAIMER = 'This is general information based on your Canopy data, not financial, tax or legal advice.';
